import React from 'react';
import { RunCircleRounded, MopedRounded, CheckCircleRounded } from "@mui/icons-material";
import { Stack, Tooltip, IconButton } from "@mui/material";

type ActionStatus = 'New' | 'Processing' | 'Available' | 'Completed' | 'Cancelled';
type Props = {
  status: ActionStatus;
  onUpdateStatus: (status: ActionStatus) => void;
  isUpdating: boolean;
};
export const RequestActionBox = (props: Props) => {
  const { status, onUpdateStatus: update, isUpdating: updating } = props;

  return (
    <Stack direction='row' sx={{ alignItems: 'center' }}>
      <Tooltip title='Set as Processing'>
        <IconButton onClick={() => update('Processing')} color="warning" disabled={status !== 'New' || updating}>
          <RunCircleRounded />
        </IconButton>
      </Tooltip>
      <Tooltip title='Set as Ready for Pickup'>
        <IconButton onClick={() => update('Available')} color="secondary" disabled={(status !== 'New' && status !== 'Processing') || updating}>
          <MopedRounded />
        </IconButton>
      </Tooltip>
      <Tooltip title='Set as Completed'>
        <IconButton onClick={() => update('Completed')} color="success" disabled={(status === 'Completed' || status === 'Cancelled') || updating}>
          <CheckCircleRounded />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};